export default __webpack_public_path__ + "static/media/instagram_comment.8e09acaa.svg";